import AWS from 'aws-sdk';
import {accounts} from '../../../universal/resources/accounts.json';
import {regions} from '../../../universal/resources/regions.json';

// TODO: This code needs changing to refer to an API via API Gateway and Lambda rather than having the logic inside the website.

export default credentials => {

  const roles = {};

  // create a new STS instance for the purpose of assuming roles in other accounts.
  const STS = new AWS.STS({
    region: 'eu-west-1',
    accessKeyId: credentials.accessKeyId,
    secretAccessKey: credentials.secretAccessKey,
    sessionToken: credentials.sessionToken
  });

  //Declare all instances outside the promise.
  const allInstances = [];

  //Total number of account/region combinations.
  const totalProfiles = accounts.length * regions.length;
  let currentProfile = 0;

  return new Promise((resolve, reject) => {

    regions.forEach(region => {
      accounts.forEach(account => {

        let EC2;

        new Promise((resolve, reject) => {
          // due to our account already being in the root account we can't assume a role within it so we must use the
          // root credentials to access it. This empty promise allows us to control this flow.

          if (account.id === '704490916269') {
            // root account. Pass through the credentials.
            resolve({
              Credentials: {
                AccessKeyId: credentials.accessKeyId,
                SecretAccessKey: credentials.secretAccessKey,
                SessionToken: credentials.sessionToken
              }
            });
          } else {

            const policy = JSON.stringify({
              'Version': '2012-10-17',
              'Statement': [
                {
                  'Sid': 'VisualEditor0',
                  'Effect': 'Allow',
                  'Action': ['ec2:DescribeInstances'],
                  'Resource': '*'
                }
              ]
            });

            // every other account. Obtain temporary credentials.
            resolve(STS.assumeRole({
              RoleArn: `arn:aws:iam::${account.id}:role/InfrastructureEC2Access`,
              RoleSessionName: 'EC2TagChanging',
              Policy: policy
            }).promise());
          }
        })
        .then(res => {
          // accessing the instances.

          const accessKeyId = res.Credentials.AccessKeyId;
          const secretAccessKey = res.Credentials.SecretAccessKey;
          const sessionToken = res.Credentials.SessionToken;
          EC2 = new AWS.EC2({region, accessKeyId, secretAccessKey, sessionToken});
          return EC2.describeInstances({}).promise();
        })
        .then(res => {
          const instances = [];
          res.Reservations.forEach(ele => {
            instances.push(...ele.Instances);
          });
          instances.forEach(ele => {
            ele.region = region;
            ele.accountId = account.id;
            ele.accountName = account.name;
            if (ele.accountName === 'Weaveability') {
              if (ele.Tags.find(tag => tag.Key === 'Client')) {
                ele.accountName = ele.Tags.find(tag => {
                  return tag.Key === 'Client';
                }).Value;
              } else ele.accountName = '*NO CLIENT*';
            };
            if (ele.Tags.find(tag => tag.Key === 'Name')) {
              ele.name = ele.Tags.find(tag => {
                return tag.Key === 'Name';
              }).Value;
            } else ele.name = '*NO NAME*';
            if (ele.Tags.find(tag => tag.Key === 'Role')) {
              ele.role = ele.Tags.find(tag => {
                return tag.Key === 'Role';
              }).Value;
            } else ele.role = '*NO ROLE*';
            roles[ele.role] = true;
            // console.log(roles);
          });
          currentProfile++;
          allInstances.push(...instances);
          if (currentProfile === totalProfiles) allInstancesFound();
        })
        .catch(err => {
          currentProfile++;
          if (currentProfile === totalProfiles) allInstancesFound();
        });

      });
    });

    const allInstancesFound = () => {
      resolve(allInstances);
    };

  });

};


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/util/getAllInstances.js